import {
  FETCH_SUPPORTUSERSLIST_SUCCESS_ACTION,
  FETCH_SUPPORTUSERS_SEARCH_SUCCESS_ACTION,
} from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_SUPPORTUSERSLIST_SUCCESS_ACTION:
      return {
        ...state,
        supportUsersList: action.payload.rows,
        supportUsersDtlsCount: action.payload.count,
      };
    case FETCH_SUPPORTUSERS_SEARCH_SUCCESS_ACTION:
  
      return {
        ...state,
        supportUsersSearchList: action.payload.rows,
        supportUsersSearchCount:action.payload.count
      };
   

    default:
      return {
        ...state,
      };
  }
}
